export default __webpack_public_path__ + "static/media/NW0070.34I-34480_-18974_0.b0f1c984.jpg";